import { GoalBasedFinancialPlanSingleResponse } from "@fartherfinance/frontend/api/FinancialPlans/plan/types";
import {
  AltAssetId,
  ExternalAccountId,
  FartherAccountId,
} from "@fartherfinance/frontend/api/Types";

export type Section = "income" | "savings" | "expenses" | undefined;

export const isAssetLinkedInAnotherCategoryCard = (
  accountId: FartherAccountId | AltAssetId | ExternalAccountId,
  plan: GoalBasedFinancialPlanSingleResponse | undefined
): [boolean, Section] => {
  if (plan === undefined) {
    return [false, undefined];
  }

  if (
    plan.income.some(
      (i) => i.depositAccount === accountId || i.sourceAccount === accountId
    )
  ) {
    return [true, "income"];
  }

  if (plan.savings.some((s) => s.account === accountId)) {
    return [true, "savings"];
  }

  if (plan.expenses.some((e) => e.paymentAccountId === accountId)) {
    return [true, "expenses"];
  }

  return [false, undefined];
};
